<template>
  <div class="app-content pt-3 p-md-3 p-lg-4">
    <div class="container-fluid">
      <h1 class="app-page-title mb-4">My Profile</h1>

      <div class="row g-4">
        <div class="col-12 col-lg-6">
          <div class="app-card shadow-sm h-100">
            <div class="app-card-header p-3 border-bottom-0">
              <h4 class="app-card-title m-0">
                <b-icon icon="person-circle" class="mr-2"></b-icon>Account Information
              </h4>
            </div>
            <div class="app-card-body p-4">
              <div class="text-center mb-4" v-if="profileImg">
                <img
                  :src="profileImg"
                  alt="Profile"
                  class="rounded-circle"
                  style="width: 100px; height: 100px; object-fit: cover;"
                  @error="$event.target.style.display='none'"
                />
              </div>
              <div class="item border-bottom py-3">
                <div class="row">
                  <div class="col-4 text-muted">Name</div>
                  <div class="col-8"><strong>{{ fullName }}</strong></div>
                </div>
              </div>
              <div class="item border-bottom py-3">
                <div class="row">
                  <div class="col-4 text-muted">Email</div>
                  <div class="col-8">{{ userEmail }}</div>
                </div>
              </div>
              <div class="item border-bottom py-3" v-if="userPhone">
                <div class="row">
                  <div class="col-4 text-muted">Phone</div>
                  <div class="col-8">{{ userPhone }}</div>
                </div>
              </div>
              <div class="item border-bottom py-3" v-if="deptName">
                <div class="row">
                  <div class="col-4 text-muted">Department</div>
                  <div class="col-8">{{ deptName }}</div>
                </div>
              </div>
              <div class="item py-3">
                <div class="row">
                  <div class="col-4 text-muted">Role(s)</div>
                  <div class="col-8">
                    <b-badge
                      v-for="role in userRoles"
                      :key="role"
                      variant="primary"
                      class="mr-1"
                    >{{ role }}</b-badge>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-12 col-lg-6">
          <div class="app-card shadow-sm h-100">
            <div class="app-card-header p-3 border-bottom-0">
              <h4 class="app-card-title m-0">
                <b-icon icon="shield-check" class="mr-2"></b-icon>Session Info
              </h4>
            </div>
            <div class="app-card-body p-4">
              <div class="item border-bottom py-3">
                <div class="row">
                  <div class="col-4 text-muted">Role in Use</div>
                  <div class="col-8">
                    <b-badge variant="info">{{ roleInUse || 'N/A' }}</b-badge>
                  </div>
                </div>
              </div>
              <div class="item border-bottom py-3">
                <div class="row">
                  <div class="col-4 text-muted">Auth Status</div>
                  <div class="col-8">
                    <b-badge :variant="isAuthenticated ? 'success' : 'danger'">
                      {{ isAuthenticated ? 'Authenticated' : 'Not Authenticated' }}
                    </b-badge>
                  </div>
                </div>
              </div>
              <div class="item py-3">
                <div class="row">
                  <div class="col-4 text-muted">Token</div>
                  <div class="col-8">
                    <code v-if="hasToken">{{ maskedToken }}</code>
                    <span v-else class="text-muted">No token</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="app-card shadow-sm mt-4">
            <div class="app-card-header p-3 border-bottom-0">
              <h4 class="app-card-title m-0">
                <b-icon icon="box-arrow-right" class="mr-2"></b-icon>Actions
              </h4>
            </div>
            <div class="app-card-body p-4">
              <button class="btn btn-danger" @click="handleLogout">
                <b-icon icon="power" class="mr-1"></b-icon> Logout
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    userData() {
      return this.$store.state.user || {};
    },
    userObj() {
      return this.userData.user || {};
    },
    fullName() {
      let parts = [this.userObj.surname, this.userObj.firstname, this.userObj.lastname].filter(Boolean);
      return parts.length ? parts.join(" ") : this.userObj.name || "N/A";
    },
    userEmail() {
      return this.userObj.email || "N/A";
    },
    userPhone() {
      return this.userObj.phone || this.userObj.mobile || "";
    },
    profileImg() {
      return this.userData.profileImg || this.userObj.picture || "";
    },
    deptName() {
      return this.userData.deptName || "";
    },
    userRoles() {
      return this.userData.roles || [];
    },
    roleInUse() {
      return this.userData.roleInUse || "";
    },
    isAuthenticated() {
      return this.$store.getters.isAuth;
    },
    hasToken() {
      return !!this.userData.token;
    },
    maskedToken() {
      let t = this.userData.token || "";
      if (t.length <= 10) return t;
      return t.substring(0, 6) + "..." + t.substring(t.length - 4);
    },
  },
  methods: {
    handleLogout() {
      Swal.fire({
        title: "Logout?",
        text: "Are you sure you want to logout?",
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "Yes, logout",
      }).then((result) => {
        if (result.isConfirmed) {
          axios.post("admin/logout").catch(() => {});
          this.$store.dispatch("logout", "signout");
          this.$router.push({ name: "Login" });
        }
      });
    },
  },
};
</script>
